const CustomBrokrage = () => {
    return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
            Customs House Brokerage
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              Regardless of the goods’ port of entry/exit, TCS covers the entire spectrum of customs services including 
              import, export, transit customs clearance, supply chain valuation, customs consulting and complex customs 
              solutions. We will help you stay ahead of ever changing custom regulations and compliance laws.
            </p>
            
            
          </div>
          <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
            <img src="/international-freight/customshouse.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </div>
      
      </div>


    </div>

    

    )
};
export default CustomBrokrage;